import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ConfirmBox from "./components/Common/ConfirmBox/Confirmbox";

const BlockBrowserBack = () => {
    const location = useLocation();
  const [showBackConfirm, setShowBackConfirm] = useState(false);

  useEffect(() => {
    const fullPath = window.location.pathname + window.location.search;
      const isHome = fullPath === "/life-insurance" || fullPath === "/life-insurance/";
      if (isHome) {
          return;
      }

      const currentState = {
          ...window.history.state,
          ...location.state,
          blockBack: true,
      };

      window.history.replaceState(currentState, "", fullPath);
      window.history.pushState(currentState, "", fullPath);

    const handlePopState = () => {
        window.history.go(1);
        setShowBackConfirm(true);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname]);

  const handleConfirmBack = () => {
      setShowBackConfirm(false);
      window.location.replace(`${window.location.origin}/life-insurance`);
  };

  const handleCloseConfirm = () => {
    setShowBackConfirm(false);
  };

  return (
    <ConfirmBox
      show={showBackConfirm}
      title="Leave page?"
      message="Clicking back will return you to the homepage. Do you want to continue?"
          showConfirmButton
      confirmText="Yes, go home"
      cancelText="Stay here"
      onConfirm={handleConfirmBack}
      onClose={handleCloseConfirm}
    />
  );
};

export default BlockBrowserBack;